export default __webpack_public_path__ + "static/media/control-icon.2275f140.png";